import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { FEEDBACK_TYPES } from '../../../../../constants/errorConstants';
import { CatInlineNotification } from '@blocks-react/components/InlineNotification';
import { CatIconWarningTriangle } from '@blocks-react/components/Icons/WarningTriangle';
import { CatButton } from '@blocks-react/components/Button';
import { useSelector } from 'react-redux';
import WrapperContainer from '@app/components/common/WrapperContainer';
import {
  DealerLocatorModalWrapper,
  CheckPriceDescription as CheckPriceDescriptionBlocks
} from '@app/components/dealer-locator-react';
import { useModal } from '@cat-ecom/pcc-components';
import ContactDealerActions from '@app/components/common/product/ProductPrimaryActions/ContactDealerActions';
import { useBreakpoint } from '@app/hooks';
import { PAGE_BREAKPOINTS } from '@app/constants/commonConstants';

const ProductSystemFeedbackBlocks = ({
  quantityAvailable,
  replacementParts,
  partNumber,
  catEntryId
}) => {
  const [t] = useTranslation();
  const isCatCorp = useSelector(s => s.common.isCatCorp);
  const isMD = useBreakpoint(PAGE_BREAKPOINTS.MD);
  let message;
  let title = 'PART_DISCONTINUED';

  if (quantityAvailable > 0 && replacementParts?.length >= 1) {
    message = 'REPLACEMENT_AVAILABLE';
  } else if (quantityAvailable === 0 && !replacementParts?.length) {
    message = 'DISCONT_CONTACT_DEALER';
  } else if (quantityAvailable > 0) {
    message = 'LIMITED_INVENTORY_AVAILABLE';
    title = 'PART_DISCONT';
  }

  const modal = useModal({
    isRequired: false,
    heading: t('CAT_CHECK_PRICE'),
    backButton: false,
    size: 'md'
  });

  const getCheckPriceAction = () => (
    <>
      <CatButton onClick={modal.initiatorProps.onClick}>
        {t('CONTACT_YOUR_DEALER')}
      </CatButton>
      <WrapperContainer>
        <DealerLocatorModalWrapper modal={modal}>
          <CheckPriceDescriptionBlocks />
        </DealerLocatorModalWrapper>
      </WrapperContainer>
    </>
  );

  return (
    message && (
      <div className="mb-3">
        <CatInlineNotification
          heading={t(title)}
          variant={FEEDBACK_TYPES.WARNING}
        >
          <CatIconWarningTriangle slot="before" />
          <div className="my-1">{t(message)}</div>
          <div
            slot="after"
            style={isMD ? { minWidth: '130px' } : { minHeight: '40px' }}
          >
            {isCatCorp ? (
              getCheckPriceAction()
            ) : (
              <div style={{ position: 'absolute' }}>
                <ContactDealerActions
                  partNumber={partNumber}
                  catEntryId={catEntryId}
                  showSmallVariant
                  initiator={<CatButton>{t('CONTACT_YOUR_DEALER')}</CatButton>}
                />
              </div>
            )}
          </div>
        </CatInlineNotification>
      </div>
    )
  );
};

ProductSystemFeedbackBlocks.propTypes = {
  quantityAvailable: PropTypes.number,
  replacementParts: PropTypes.arrayOf(
    PropTypes.shape({
      uniqueId: PropTypes.string
    })
  ),
  partNumber: PropTypes.string,
  catEntryId: PropTypes.string
};

export default ProductSystemFeedbackBlocks;
